/* src/app/content-editor/editor-toolbar/editor-toolbar.component.scss */
:host {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 32px 16px;
  border-bottom: 0.5px solid var(--border);
  background: #fff;
  flex-shrink: 0;
}
.crumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 12px;
  color: var(--text-tertiary);
}
.crumbs span {
  white-space: nowrap;
}
.crumbs .crumb-strong {
  color: var(--text-secondary);
  font-weight: 600;
}
.version-pill {
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--teal-bg);
  color: var(--teal-text);
  font-size: 11px;
  font-weight: 700;
}
.toolbar-spacer {
  flex: 1;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.inline-search {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 220px;
  padding: 0 10px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-tertiary);
}
.inline-search input {
  width: 100%;
  border: 0;
  background: transparent;
  outline: none;
  padding: 8px 0;
  color: var(--text-primary);
  font-size: 13px;
}
.toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 0.5px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  border-radius: 8px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.12s ease;
  white-space: nowrap;
}
.toolbar-btn:hover {
  border-color: var(--border-hover);
  color: var(--text-primary);
}
.toolbar-btn.active {
  background: var(--accent-light);
  color: var(--accent);
  border-color: rgba(12, 68, 124, 0.2);
}
.toolbar-btn.primary {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}
.toolbar-btn .caret {
  font-size: 10px;
}
.toolbar-chip-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 8px;
  margin-left: 4px;
  border-left: 1px solid var(--border);
}
.toolbar-dropdown {
  position: relative;
}
.save-toolbar-trigger {
  anchor-name: --save-toolbar-anchor;
}
.toolbar-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 190px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.12);
  padding: 6px 0;
  z-index: 20;
}
.toolbar-popover {
  margin: 0;
  inset: auto;
  min-width: 190px;
  max-width: 240px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.12);
  padding: 6px 0;
  color: var(--text-primary);
}
.toolbar-popover:popover-open {
  position: fixed;
  position-anchor: --edit-toolbar-anchor;
  top: anchor(bottom);
  left: anchor(right);
  transform: translate(-100%, 6px);
}
#save-toolbar-popover:popover-open {
  position-anchor: --save-toolbar-anchor;
}
.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 14px;
  border: 0;
  background: transparent;
  color: var(--text-secondary);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}
.dropdown-item:hover:not([disabled]) {
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.dropdown-item[disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}
/*# sourceMappingURL=editor-toolbar.component.css.map */
